import { NgModule } from "@angular/core";
import { ReminderReplayDialog } from './replay.component';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@fuse/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FusePipesModule } from 'app/core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { EditImageModule } from 'app/main/pages/edit-image/edit-image.module';

@NgModule({
    declarations: [
        ReminderReplayDialog
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule,
        FusePipesModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        DatePickerModule,
        NgxMatSelectSearchModule,
        EditImageModule
    ],
    exports:[
        ReminderReplayDialog
    ],
    entryComponents: [
        ReminderReplayDialog
    ]
})

export class ReplayModule {

}